// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6171 ? "11f72889" : chunkId) + "." + {"6171":"73ab3e0aaa7e315a","8311":"37e8beaea8393e98"}[chunkId] + ".js";
};